var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-image"},[_c('div',{staticClass:"img",style:(_vm.headerImage
        ? ("background-image: url('" + _vm.headerImage + "'); background-color: #000;")
        : '')},[_c('div',{staticClass:"darken-wrapper"}),_c('div',{staticClass:"left-big"}),_c('div',{staticClass:"right-big"}),_c('div',{staticClass:"wrapper-text"},[_c('HeaderTitle')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }